// Package Imports
import React from 'react';
import '@refinedev/antd/dist/reset.css';
// Project Imports
import Initiate from 'Initiate';

import { useTokenContext } from 'contexts/resource/ResourceContext';
import Loading from 'components/loading/loading';

const App = () => {
  const { loading } = useTokenContext();
  if (loading) {
    return <Loading />;
  }
  return <Initiate />;
};

export default App;
